import cn from 'classnames';
import PropTypes from 'prop-types';

const ImageSwitcher = ({
  baseSrc, alt, className, ...attrs
}) => (
  <>
    <img src={`${baseSrc}.svg`} alt={alt} {...attrs} className={cn(className, 'd-xl-block', 'd-none')} />
    <img src={`${baseSrc}-1024.svg`} alt={alt} {...attrs} className={cn(className, 'd-lg-block', 'd-xl-none', 'd-none')} />
    <img src={`${baseSrc}-768.svg`} alt={alt} {...attrs} className={cn(className, 'd-md-block', 'd-lg-none', 'd-none')} />
    <img src={`${baseSrc}-375.svg`} alt={alt} {...attrs} className={cn(className, 'd-md-none', 'd-block')} />
  </>
);

ImageSwitcher.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  baseSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default ImageSwitcher;
